import React, { useEffect } from "react";
import { useState } from "react";
import Header from "../../components/headers/Header";
import { MiFooter } from "../../components/footer/MiFooter";
import '../PerfilAgencia/PerfilAgenciaNuevo.css'
import '../PerfilAgencia/PerfilAgencia.css'
import { FormularioValoraciones } from "../../components/Valoraciones/FormularioValoraciones";

export const Valoraciones = (props) => {
    const [MenuLateralAux, setMenuLateralAux] = useState();

    const chageMenuLateralAux = () => {
        setMenuLateralAux(!MenuLateralAux)
    }

    return (
        <>
            <div className='PerfilAgencia'>
                <div className='headerPerfilAgencia'>
                    <Header 
                        chageMenuLateralAux={chageMenuLateralAux}
                    />
                </div>
                <FormularioValoraciones />
                <div className='footerPerfilAgencia'>
                    <MiFooter />
                </div>
            </div>
        </>
    )
}